import { hashTestIdValue } from '@lucidlink/uicore/interactions';
export const GuestsTabTestIdFactory = {
    getOpenGuestDetailsTestId: (email) => ['open-guest-details', hashTestIdValue(email)].join('-'),
};
